import { cn } from '@/utils/helpers';

export type CopyIconProps = {
  className?: string;
};

/** Two overlapping squares — copy / duplicate (Figma 18×18). */
export function CopyIcon({ className }: CopyIconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      className={cn('copy-icon', className)}
      aria-hidden
    >
      <rect
        x="5.25"
        y="5.25"
        width="10.5"
        height="10.5"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4.5 12.75H3.75C2.92157 12.75 2.25 12.0784 2.25 11.25V3.75C2.25 2.92157 2.92157 2.25 3.75 2.25H11.25C12.0784 2.25 12.75 2.92157 12.75 3.75V4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
